import { OTHER_NODES_LABEL } from "@faire/help-center-self-serve/shared/other-node";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Insider } from "@faire/web/slate/icons/InsiderIcon";
import React from "react";
import { BenefitsIA } from "../instantAnswers/insiderMembership-benefits";
import { BrandDoesNotHaveInsiderFreeShippingIA } from "../instantAnswers/insiderMembership-brandDoesNotHaveInsiderFreeShipping";
import { CancelMembershipIA } from "../instantAnswers/insiderMembership-cancelMembership";
import { DidNotGetInsiderFreeDutiesIA } from "../instantAnswers/insiderMembership-didNotGetInsiderFreeDuties";
import { DidNotGetInsiderFreeShippingIA } from "../instantAnswers/insiderMembership-didNotGetInsiderFreeShipping";
import { HowToFindBrandsThatHaveInsiderFreeShippingIA } from "../instantAnswers/insiderMembership-howToFindBrandsThatHaveInsiderFreeShipping";
import { PauseMembershipIA } from "../instantAnswers/insiderMembership-pauseMembership";
import { ManageInsiderMembershipVisibilityFn } from "../visibilityFunctions/manageInsiderMembershipVisibilityFn";
export var useInsiderRetailerNodes = function useInsiderRetailerNodes() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Insider: {
      id: "Insider",
      label: strictLocalize({
        id: "HFELLO",
        defaultMessage: [{
          "type": 0,
          "value": "Insider"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Insider, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["AboutInsider", "InsiderFreeShippingCoverage", "InsiderFreeShippingIssue", "InsiderFreeDutiesIssue", "BrandNoLongerCovered", "PauseMembership", "CancelMembership", "OtherInsiderMembership"],
      level: level - 1,
      sidebarTitle: strictLocalize({
        id: "1hi1J3",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met een Insider-lidmaatschap"
        }]
      })
    },
    AboutInsider: {
      id: "AboutInsider",
      label: strictLocalize({
        id: "zS+yut",
        defaultMessage: [{
          "type": 0,
          "value": "Over Insider"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: BenefitsIA(strictLocalize),
      level: level
    },
    InsiderFreeShippingCoverage: {
      id: "InsiderFreeShippingCoverage",
      label: strictLocalize({
        id: "0fMXi1",
        defaultMessage: [{
          "type": 0,
          "value": "Gratis verzending met Insider"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: HowToFindBrandsThatHaveInsiderFreeShippingIA(strictLocalize),
      level: level
    },
    InsiderFreeShippingIssue: {
      id: "InsiderFreeShippingIssue",
      label: strictLocalize({
        id: "dHCgPE",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met Gratis verzending met Insider"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: DidNotGetInsiderFreeShippingIA(strictLocalize),
      level: level
    },
    InsiderFreeDutiesIssue: {
      id: "InsiderFreeDutiesIssue",
      label: strictLocalize({
        id: "rIncg0",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met Gratis invoerrechten met Insider"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      instantAnswer: DidNotGetInsiderFreeDutiesIA(strictLocalize),
      level: level
    },
    BrandNoLongerCovered: {
      id: "BrandNoLongerCovered",
      label: strictLocalize({
        id: "X0llxL",
        defaultMessage: [{
          "type": 0,
          "value": "Merk niet meer gedekt"
        }]
      }),
      instantAnswer: BrandDoesNotHaveInsiderFreeShippingIA(strictLocalize),
      level: level
    },
    PauseMembership: {
      id: "PauseMembership",
      label: strictLocalize({
        id: "cloO+b",
        defaultMessage: [{
          "type": 0,
          "value": "Mijn lidmaatschap onderbreken"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      isNodeVisible: ManageInsiderMembershipVisibilityFn,
      instantAnswer: PauseMembershipIA(strictLocalize),
      level: level
    },
    CancelMembership: {
      id: "CancelMembership",
      label: strictLocalize({
        id: "xQ2Ixr",
        defaultMessage: [{
          "type": 0,
          "value": "Lidmaatschap annuleren"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      isNodeVisible: ManageInsiderMembershipVisibilityFn,
      instantAnswer: CancelMembershipIA(strictLocalize),
      level: level
    },
    OtherInsiderMembership: {
      id: "OtherInsiderMembership",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.FAQ.FAIRE_INSIDER_US, articles.FAQ.FAIRE_INSIDER_EU],
      level: level
    }
  };
};